import { render, staticRenderFns } from "./ResultsChart.vue?vue&type=template&id=00b7a427&scoped=true&"
import script from "./ResultsChart.vue?vue&type=script&lang=js&"
export * from "./ResultsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b7a427",
  null
  
)

export default component.exports